<script>import { onDestroy, onMount, setContext } from 'svelte';
import { IcuFormatter, Tolgee, TolgeeConfig } from '@tolgee/core';
export let config;
const tolgee = Tolgee.use(IcuFormatter).init({
    wrapperMode: 'invisible',
    ui: process.env.NODE_ENV !== 'development'
        ? undefined
        : typeof require !== 'undefined'
            ? require('@tolgee/ui')
            : import('@tolgee/ui'),
    ...(config || new TolgeeConfig()),
});
let tolgeeRunPromise;
setContext('tolgeeContext', {
    tolgee,
});
if (typeof window !== 'undefined') {
    onMount(() => (tolgeeRunPromise = tolgee.run()));
    onDestroy(tolgee.stop);
}
</script>

{#if !tolgee.initialLoading}
  <slot />
{:else if !tolgeeRunPromise}
  <slot name="loading-fallback" />
{:else}
  {#await tolgeeRunPromise}
    <slot name="loading-fallback" />
  {:then _}
    <slot />
  {/await}
{/if}
